export default __webpack_public_path__ + "static/media/pagination-right.7b9189c5.svg";